
export { feedDataAtom } from "/home/runner/work/capsicum/capsicum/libs/features/feeds/shared/src/data-access/atoms/feedData.atom.ts"